// Global Elements
import { initHeader } from './global-elements/header';
import { initHeroButtons } from './global-elements/hero-buttons';
import { initMenuDescriptions } from './global-elements/menu-descriptions';
import { utmParameters } from './global-elements/form-utm';
// import { initLineDecor } from './global-elements/line-decor';
// import { initHeroSize } from './global-elements/hero-size';

// Modules
import { initToggleContent } from './modules/toggle';
import { initNewsEvents } from './modules/news-events';
import { initFaqScroll } from './modules/faq-scroll';
import { propertyFilterPlaceholder } from './modules/property-filter-placeholder';
import { blogExcerptLength } from './modules/blog-excerpt';
import { passwordProtected } from './modules/password-protected';
import { initGridGallery } from './modules/grid-gallery';
import { numberCounter } from './modules/number-counter';
import { animateUp } from './modules/animate-up';
import { initRemoveLineDecor } from './modules/remove-line-decor';
import { initBlogAuthor } from './modules/blog-author';
import { initPropertyTitle } from './modules/property-title';
import { initHeroButton } from './modules/hero-button';
import { initHeroStats } from './modules/hero-stats';
import { initHeroContact } from './modules/hero-contact-form';
import { initTabScroll } from './modules/tab-scroll';
import { initRemoveFeaturedTag } from './modules/featured-tag';
import { initRemoveTags } from './modules/remove-tags';
// import { initMemberBioEmail } from './modules/team-bio-email';

// Charts
import { initChartWithToggle } from './charts/chart-with-toggle';
import { initTreemap } from './charts/treemap';
import { initLineChart } from './charts/line-chart';
import { initBarChart } from './charts/bar-chart';
import { initDualAxisChart } from './charts/dual-axis-chart';
import { initAnnotatedChart } from './charts/annotated-chart';
import { initChartSlider } from './charts/chart-slider';
// -----------------------------------------------------------------------------

const init = () => {
  // Shortcodes
  // Global Elements
  initHeader();
  initHeroButtons();
  initMenuDescriptions();
  utmParameters();
  // initLineDecor();
  // initHeroSize();

  // Modules
  initToggleContent();
  initNewsEvents();
  initFaqScroll();
  propertyFilterPlaceholder();
  blogExcerptLength();
  passwordProtected();
  numberCounter();
  animateUp();
  initRemoveLineDecor();
  initBlogAuthor();
  initPropertyTitle();
  initHeroButton();
  initHeroStats();
  initHeroContact();
  initTabScroll();
  // initMemberBioEmail();
  initRemoveFeaturedTag();
  initRemoveTags();

  // Charts
  document.addEventListener('DOMContentLoaded', () => {
    initChartWithToggle();
    initTreemap();
    initLineChart();
    initBarChart();
    initDualAxisChart();
    initAnnotatedChart();
    initGridGallery();

    // Initialize chart slider after charts have rendered
    setTimeout(() => {
      initChartSlider();
    }, 100);
  });
};

init();
